import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Iframe sandbox safety net: hosted preview iframes may deny certain
// permissions (e.g. clipboard-write, download). Browser APIs that reject in
// that sandbox bubble up as "uncaught" runtime errors and blank the UI in
// dev. Swallow them globally so the app stays usable.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const msg = String(event?.reason?.message || event?.reason || '');
    if (/Clipboard|clipboard|NotAllowedError|permissions policy/i.test(msg)) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
